import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ACCOUNT_ROUTE_URLS, SUPPORT_ROUTE_URLS } from 'src/app/app.routes.names';

@Component({
  selector: 'app-fourth-generation-page',
  templateUrl: './fourth-generation-page.component.html',
  styleUrls: ['./fourth-generation-page.component.scss']
})

export class AndroidFourthGenerationPageComponent {
  public ACCOUNT_ROUTE_URLS = ACCOUNT_ROUTE_URLS;
  public instructionTable = [
    { key: 'Name:', value: 'FreeUp Mobile' },
    { key: 'APN:', value: 'RESELLER' },
    { key: 'Proxy:', value: 'Not set' },
    { key: 'Port:', value: 'Not set' },
    { key: 'Username:', value: 'Not set' },
    { key: 'Password:', value: 'Not set' },
    { key: 'Server:', value: 'Not set' },
    { key: 'MMSC:', value: 'http://mmsc.mobile.att.net', href: true },
    { key: 'MMS Proxy:', value: 'proxy.mobile.att.net', href: false },
    { key: 'MMS Port:', value: '80' },
    { key: 'MCC:', value: '310' },
    { key: 'MNC:', value: '410' },
    { key: 'Authentication Type:', value: 'None' },
    { key: 'APN Type:', value: 'default,supl,mms,fota' },
    { key: 'APN protocol:', value: 'IPv4/IPv6' },
    { key: 'Bearer:', value: 'Unspecified' }
  ];

  constructor(
    public router: Router) { }

  public back(): void {
    this.router.navigate([`${SUPPORT_ROUTE_URLS.BASE}/${SUPPORT_ROUTE_URLS.ATT_ANDROID}`]);
  }
}
